import { ContactSupport } from './ContactSupport';

export default ContactSupport;
